exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itemNoti{\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 13px;\n    border-bottom: 1px solid #ebe7e7;\n    cursor: pointer;\n}\n.itemNoti:hover{\n    background-color: rgb(252, 246, 249)\n}\n.iconNoti{\n    -ms-flex-negative: 0px;\n        flex-shrink: 0px;\n    padding: 10px;\n    padding-left: 0px;\n\n}\n.contentNoti{\n    -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n}\n.loadmore{\n    cursor: pointer;\n}\n.loadmore:hover{\n    color: rgb(144, 121, 238)\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/notifications/notifications/notifications.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/notifications/notifications/notifications.component.css
// module chunks = 3